import { RunContextApp }                              from "framework/RCApp";
import { CMSApiResponse }                          from "framework/http/CMSApiClient";
import { UserRoleInfo }                               from "types/apis/sessionInterfaces";

export const SessionApis = {

  login : async (rc: RunContextApp, username : string, password : string) : Promise<any> => {

    let resp
    if (process.env.REACT_APP_HOME_PAGE === 'CMS') {
      resp = await rc.cmsApiClient.login(username, password)
    } else {
      resp = await rc.bffClient.login(username, password)
    }
    
    return resp
  },

  getUserRoleInfo : async (rc: RunContextApp) : Promise<CMSApiResponse<UserRoleInfo>> => {

    const resp = await rc.cmsApiClient.get<UserRoleInfo>(`/users/${rc.session.getUserInfo()?.id}`)
    return resp
  }

}